import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useRequest } from './useRequest';
import { API_PATH } from '../types/shared';
import { getRequestBaseParams } from '../utils/request';
// R001：将 CardItemDetailVO[] 映射为 LandmarkViewModel[]，字段与 CardInfo 对齐
function resolveCardGroupLandmarks(cards) {
    const landmarks = cards.map(card => {
        let cardExtra = {};
        try {
            cardExtra = JSON.parse(card.cardExtra || '{}');
        }
        catch { }
        return {
            cardId: card.cardId,
            name: card.cardName,
            description: '',
            cover: card.cardImage,
            icon: card.cardImage,
            obtained: card.obtained,
            sortOrder: card.sortOrder,
            cardExtra
        };
    });
    return landmarks.sort((a, b) => {
        if (a.obtained !== b.obtained)
            return a.obtained ? -1 : 1;
        return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
    });
}
// R001：封装 3.9 接口，返回请求函数，由调用方管理状态和触发时机
export function useCardGroupDetail(options) {
    const ctx = useMonitorEngineContext();
    const commonParams = ctx._runtimeInfo?.commonParams;
    const { request } = useRequest(API_PATH.CARD_GROUP_DETAIL);
    async function loadCardGroupDetail(packId, groupKey) {
        try {
            const feCommonParams = await getRequestBaseParams(commonParams);
            const res = await request({
                activityId: options.activityId,
                packId,
                groupKey,
                ...feCommonParams
            });
            ctx._raptorReport.monitorReportBizSuccess?.({
                apiPath: API_PATH.CARD_GROUP_DETAIL
            });
            if (Array.isArray(res?.cards)) {
                return resolveCardGroupLandmarks(res.cards);
            }
            return [];
        }
        catch (error) {
            ctx._raptorReport.monitorReportBizFailed?.({
                apiPath: API_PATH.CARD_GROUP_DETAIL
            });
            ctx._raptorReport.monitorReportLog(error.message, error, {
                category: 'ajaxError',
                level: 'error'
            });
            return [];
        }
    }
    return {
        loadCardGroupDetail
    };
}
